import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { articlesKeys } from '../articlesKeys'
import { SuggestionRequestWithRequester } from 'types'
import { sendToApi } from 'api/client'
import { useRootStore } from 'stores/RootStore'

interface Props {
  articleId: string
  layerId: string
  id: number
}

const fetchSuggestionRequest = (articleId: string, layerId: string, id: number) =>
  sendToApi<{ request: SuggestionRequestWithRequester }>(
    `/articles/${articleId}/layers/${layerId}/ai_suggestion_requests/${id}`,
  )

export const useAISuggestionRequest = (
  { articleId, layerId, id }: Props,
  options?: UseQueryOptions<{ request: SuggestionRequestWithRequester }>,
) => {
  const aiGenerationStore = useRootStore().aiGeneration
  return useQuery<{ request: SuggestionRequestWithRequester }>(
    articlesKeys.aiSuggestionRequest(articleId, layerId, id),
    async () => {
      const res = await fetchSuggestionRequest(articleId, layerId, id)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      aiGenerationStore.upsertJobStatus(id, { articleId, layerId, status: res.data.request.status })
      return res.data
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
